<template>
  <base-section
    id="individuella-val-section"
    heading="Individuella val"
    :infoStatus="individuellaVal.infoStatus"
    :show-error="!!individuellaVal.error"
  >
    <avtalat-spinner v-if="individuellaVal.isLoading" />
    <HelpText :text="helpTexts.individuellaVal.individuellaVal" />
    <table class="section-table" v-if="!individuellaVal.isLoading">
      <tbody>
        <tr>
          <th scope="col"></th>
          <th class="border-b border-gray-200 align-text-top" scope="col">
            Gällande val
          </th>
          <th class="border-b border-gray-200 align-text-top" scope="col">
            Valdatum
          </th>
          <th class="border-b border-gray-200 align-text-top" scope="col">
            Kommentar
          </th>
        </tr>
        <tr>
          <th scope="col">Återbetalningsskydd</th>
        </tr>
        <tr
          class="aterbetalningsskyddrow"
          v-for="(
            aterbetalningsskydd, aterbetalningsskyddsIndex
          ) in individuellaVal.data?.aterbetalningsskyddList"
          :key="aterbetalningsskyddsIndex"
        >
          <th
            scope="col"
            :class="
              individuellaVal.data?.aterbetalningsskyddList?.length ===
              aterbetalningsskyddsIndex + 1
                ? 'lastaterbetalningsskydd'
                : ''
            "
          >
            {{ aterbetalningsskydd.produkttyp }}
          </th>
          <td class="font-bold">
            {{ aterbetalningsskydd.gallandeVal }}
          </td>
          <td>
            {{
              aterbetalningsskydd.giltigFrom
                ? aterbetalningsskydd.giltigFrom
                : "-"
            }}
          </td>
          <td>{{ aterbetalningsskydd.statustext }}</td>
        </tr>
        <tr
          v-if="
            individuellaVal.data?.avstaendeFamiljepension?.hasAvstaende != null
          "
        >
          <th scope="col">Avstående familjepension</th>
          <td>
            {{
              formatAsYesOrNo(
                individuellaVal.data?.avstaendeFamiljepension?.hasAvstaende,
              )
            }}
          </td>
        </tr>
        <tr>
          <th scope="col">Familjeskydd</th>
          <td>
            {{ individuellaVal.data?.familjeskydd.gallandeVal }}
          </td>
          <td>
            {{ individuellaVal.data?.familjeskydd.giltigFrom }}
          </td>
          <td>
            {{ individuellaVal.data?.familjeskydd.statustext }}
          </td>
        </tr>
      </tbody>
    </table>
  </base-section>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { BaseSection } from "@/components/sections";
import HelpText from "@/components/ui/HelpText.vue";
import helpTexts from "@/config/helpTexts";
import { formatAsYesOrNo } from "@/common/formatters";

import { useAnstalldStore } from "../store";

const anstalldStore = useAnstalldStore();
const individuellaVal = computed(() => anstalldStore.individuellaVal);
</script>
<style scoped>
.section-table table {
  border-collapse: collapse;
  width: 100%;
}

.section-table tr.aterbetalningsskyddrow > *:first-child {
  padding-left: 2em;
}

.section-table td,
.section-table th {
  position: relative;
  padding: 0.6em 0.6em;
  font-weight: var(--font-weight-normal);
  text-align: left;
}

.section-table td {
  vertical-align: text-top;
  font-weight: 700;
}

.section-table tr.aterbetalningsskyddrow > *:first-child:before {
  display: block;
  position: absolute;
  bottom: 50%;
  left: 0.7em;
  border-bottom: 1px solid var(--neutral-50);
  border-left: 1px solid var(--neutral-50);
  width: 1em;
  height: 50%;
  content: "";
}

.section-table tr.aterbetalningsskyddrow > *:first-child:after {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0.7em;
  border-left: 1px solid var(--neutral-50);
  width: 1em;
  height: 50%;
  content: "";
}

.section-table tr.aterbetalningsskyddrow .lastaterbetalningsskydd:after {
  border: none;
}
</style>
